package com.devi3east.bashbuddy.features.events.feed.navigation

import androidx.navigation.NavGraphBuilder
import androidx.navigation.compose.composable
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen
import com.devi3east.bashbuddy.features.events.feed.ui.EventFeedRoute

fun NavGraphBuilder.eventFeedNavGraph(
    appState: AppState,
    navigateToEventDetail: (eventId: String, slug: String) -> Unit
) {
    composable(Screen.EventsScreen.route) {
        EventFeedRoute(
            appState = appState,
            navigateToEventDetail = navigateToEventDetail
        )
    }
}